// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3esL6","fileBtn":"File_fileBtn__2L7Dz","closeBtn":"File_closeBtn__3ieuL","fileSelected":"File_fileSelected__1Lcsk","disabled":"File_disabled__fAtre"};